import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Rss02 = function Rss02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3.0002 13.0225c5.185-.7796 8.7557 2.7921 7.9772 7.9771M3.0002 8.0378c7.9378-.7796 13.7415 5.0241 12.9619 12.9619M3.0002 3.0521c10.6917-.7785 18.7262 7.2561 17.9478 17.9477M5 21c-1.1043 0-2-.8957-2-2s.8957-2 2-2 2 .8957 2 2-.8957 2-2 2"
    })
  }));
};
export default Rss02;